import axios from 'axios'
import FAMILY_BA_URL from './getapi/family_ba'

let apiURL = ''
// console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50087'
  // apiURL = 'https://gaea.haiweikexin.com/api/v1/'
}else {
  // alert("生产环境");
  apiURL = FAMILY_BA_URL
}

export default apiURL;



// WEBPACK FOOTER //
// ./src/util/familyBaApiConfig.js